import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import {
  cancelPayment,
} from './actions';
import onUnload from '../../common/hoc/onUnload';

import { t } from '../../../modules/infra/i18n';

const CancelPaymentButton = ({ action }) => {
  return (
    <button type="button" onClick={action} className="c-btn c-btn--red c-btn--medium">{t('common:modal.cancel_button')}</button>
  );
};

CancelPaymentButton.propTypes = {
  action: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  shop: state.auth.shop,
});

const mapDispatchToProps = {
  cancelPayment,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    action: props => () => {
      props.cancelPayment();
      props.afterAction();
    },
    onUnload: props => () => {
      props.cancelPayment();
    },
  }),
  onUnload,
);

export default enhance(CancelPaymentButton);
